import { render, staticRenderFns } from "./menu-node-modal.vue?vue&type=template&id=0220bdf0&"
import script from "./menu-node-modal.vue?vue&type=script&lang=js&"
export * from "./menu-node-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "menu-node-modal.vue"
export default component.exports